// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.encounter.examtestlibrary.AdminWorkflowTestTemplateSvcTriggerResponse */
/* istanbul ignore next */
@GandalfModel
export class AdminWorkflowTestTemplateSvcTriggerResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	serviceCode!: string | null;

	@GandalfConstantDecorator(constants.TriggerRuleType)
	@GandalfProperty({ designType: constants.TriggerRuleType })
	triggerRuleType!: constants.TriggerRuleType | null;

}
